import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  // Defaults to every recipient. "Not delivered" is the more analytically useful
  // view, but defaulting to it shows an empty table for any send that went
  // cleanly, which reads as "the report is broken".
  currentFilter: "all",
  sortBy: "status",
  sortOrder: "asc",
  search: "",
  clearSelection: false,
};

const notificationDeliverySlice = createSlice({
  name: "notificationDelivery",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
    resetConfig: () => initialState,
  },
  extraReducers: () => {},
});

export const { updateConfig, resetConfig } = notificationDeliverySlice.actions;

export default notificationDeliverySlice.reducer;
